<markant-dialog [open]="true" (close)="closeDialog()">
  <h4
    [innerHTML]="
      'guidedTour.sectionStartHeadline'
        | transloco
          : {
              sectionNumber: sectionNumber,
              sectionTitle:
                '<span>' +
                ('guidedTour.tours.' +
                  tourTranslationKey +
                  '.section' +
                  sectionNumber +
                  '.title' | transloco) +
                '</span>',
            }
    "
    class="headline"
  ></h4>
  <img
    [src]="
      'assets/images/guided-tours/' +
      tourTranslationKey +
      '/section' +
      sectionNumber +
      '-start.svg'
    "
    class="image"
  />
  <div
    class="text"
    [innerHTML]="
      'guidedTour.tours.' +
        tourTranslationKey +
        '.section' +
        sectionNumber +
        '.startText' | transloco
    "
  ></div>
  <div class="footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="closeDialog()"
    >
      {{ 'common.cancel' | transloco }}
    </markant-button>
    <markant-button
      class="start-button"
      colorScheme="primary"
      (click)="startTour()"
    >
      <markant-icon
        icon="m_arrow-right-small"
        slot="icon-trailing"
      ></markant-icon>
      {{ 'guidedTour.start' | transloco }}
    </markant-button>
  </div>
</markant-dialog>
